module.exports = new __parcel__URL__("swamp-floor.b656f901.webp").toString();